import React from 'react';
import { DispatchProp } from 'react-redux';
import { useSetResolved } from 'src/core/engine/router';
import { CmsArtworkPage } from 'src/components/CmsPage/CmsArtworkPage';
import { DefaultMeta } from 'src/components/AppShell/Head';
import { Wrapper } from 'src/components/Layout';

import '../../scss/_root-component.scss';

import meta from './CmsArtwork.json';

type Props = {
    id: number;
} & DispatchProp<any>;

export const CmsArtwork: React.FC<Props> = () => {
    useSetResolved();

    return (
        <Wrapper variant="widget-wrapper-no-padding">
            <DefaultMeta data={meta.helmet} />
            <CmsArtworkPage />
        </Wrapper>
    );
};

export default CmsArtwork;
